import create from 'zustand';
import { storeWithModal } from '../../Agreement/Provider/storeStates';

const rowKey = 'authorizationLevelId';
export const useEngageAuthorizationLevelStore = create(set => storeWithModal(set, rowKey));
